module.exports = __webpack_public_path__ + "static/media/sites.2f3987b9.webp";